import { TraitTypeNumericWithSlider } from '../../traitTypes/TraitTypeNumericWithSlider';
import { TraitRegistryCategory } from '../../TraitRegistryCategory';
import { TraitTypeSelect } from '../../traitTypes/TraitTypeSelect';
import { resolveAutoBorderName } from '../../TraitRegistryConstants';
export class TraitRegistryTextSize extends TraitRegistryCategory {
    label = 'Textgröße';
    constructor(parent) {
        super(parent);
        super.init();
    }
    overflowBorder = new TraitTypeSelect({
        default: 'defaultBorder',
        /*  init: 'defaultBorder',
        select: [['option'], ['questionPart'], ['answerPart'], ['auto:parentActor'], ['auto:actor']], */
        key: 'overflowBorder',
        creates: ['className'],
        createTraits: ({ at }) => [{ key: 'className', value: `overflowBorder_${resolveAutoBorderName(at)}`, traitGroup: '#CCC' }],
    });
    growBorder = new TraitTypeSelect({
        default: 'defaultBorder',
        /* init: 'defaultBorder',
        select: [['option'], ['questionPart'], ['answerPart'], ['auto:parentActor'], ['auto:actor']], */
        key: 'growBorder',
        creates: ['className'],
        createTraits: ({ at }) => [{ key: 'className', value: `growBorder_${resolveAutoBorderName(at)}`, traitGroup: '#A0A0A0' }],
    });
    textGrowChild = new TraitTypeSelect({
        /*  label: 'Automatische Textgröße',
        init: 'option',
        select: [['option'], ['questionPart'], ['answerPart'], ['auto:parentActor'], ['auto:actor']], */
        key: 'textGrowChild',
        creates: ['transition_fontSize', 'className', 'fontSize'],
        createTraits: ({ at }) => {
            if (typeof window === 'undefined')
                return [];
            const borderName = resolveAutoBorderName(at);
            if (at.aspect.global.valueOf.fontSizeManual)
                return [];
            return [
                { key: 'transition_fontSize', value: '0s' },
                { key: 'className', value: `textGrowChild_${borderName}`, traitGroup: '#F0FA0E' },
                {
                    key: 'fontSize',
                    value: () => at.context.app.textsizer.getTextSizeGroup(borderName).finalFontSize || at.aspect.valueOf.initialFontSize,
                },
            ];
        },
    });
    textGrowEnable = new TraitTypeSelect({
        default: '',
        select: [['endUser']],
    });
    textGrowMin = new TraitTypeNumericWithSlider({
        /*  label: 'Text Mindestgröße',
        init: 12,
        min: 0,
        max: 100,
        step: 1, */
        key: 'textGrowMin',
        creates: ['jsx_attr_data_textgrowmin'],
        createTraits: ({ at }) => {
            return [{ key: 'jsx_attr_data_textgrowmin', value: at.scaledValue }];
        },
    });
    textGrowMax = new TraitTypeNumericWithSlider({
        /*   label: 'Text Maximalgröße',
        init: 30,
        min: 0,
        max: 200,
        step: 1, */
        key: 'textGrowMax',
        creates: ['jsx_attr_data_textgrowmax'],
        createTraits: ({ at }) => {
            return [{ key: 'jsx_attr_data_textgrowmax', value: at.scaledValue }];
        },
    });
}
